import { Component, OnInit } from '@angular/core';
import { MyuwfService } from 'src/app/services/myuwf/myuwf.service';
import { ThemeSwitcherService } from 'src/app/services/theme/theme-switcher.service';
import { Preferences } from 'src/app/models/preferences';
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-notifications-page',
  templateUrl: 'notifications.page.html',
  styleUrls: ['notifications.page.scss']
})
export class NotificationsPage implements OnInit {

  constructor(
    private myuwfService: MyuwfService,
    public themeSwitcher: ThemeSwitcherService
  ) { }

  ngOnInit() {
    this.myuwfService.loadPreferences()
      .pipe(take(1))
      .subscribe(prefs => this.processPrefs(prefs) );
  }

  /** Process preference updates as they are encountered */
  private processPrefs(prefs: Preferences) {
    // Process theme settings
    if(prefs.theme === "dark") {
      this.themeSwitcher.setTheme('dark');
    } else if(prefs.theme === "blue") {
      this.themeSwitcher.setTheme('blue');
    } else {
      this.themeSwitcher.setTheme('default');
    }
  }
}
